import App from './app.js';
import CategoryPanel from './categories/categoryPanel';
import MultiSelect from './forms/MultiSelect';
import Navigation from './navigation/navigation';
import UI from './ui/ui';
import Tags from './forms/Tags';
import User from './users/user';
import Storm from './storms';
import Maps from './maps';
import Recovery from './recovery/recovery';
import LiveWeatherCenter from './live_weather_center';
import RoleManagement from './roleManagement/roleManagementContainer';
import Features from './features';

export * from './ui';
export * from './app/index'; //app/index because of naming conflict app.js and /app
export * from './sales';
export * from './dashboard';
export * from './client';
export * from './account';
export * from './users'
export * from './clients';
export * from './maps';
export * from './form-builder';
export * from './posts';
export * from './tasks';
export * from './pipeline';
export * from './header';
export * from './data';
export * from './opportunities';
export * from './permissions';
export * from './reports';
export * from './help';
export * from './notifications';
export * from './settings';
export * from './sales-site-manager';
export * from './map-creator';
export * from './error-logs';

export {
	App,
	UI, //TODO: Remove this component grouping in favor of index.js implementation.

	Tags,
	CategoryPanel,
	MultiSelect,
	Navigation,
	User,

	Maps, //TODO: Remove this way of exporting maps.
	Storm,

	//Recovery
	Recovery,
	LiveWeatherCenter,

	//Role Management
	RoleManagement,

	//Features
	Features
}



// WEBPACK FOOTER //
// ./src/browser/components/index.js